import AllFilterOptions from './options';
import StoreFilter from './options/store';
import CarrierFilter from './options/carrier';
import ShipFromFilter from './options/ship-from';
import CountryFilter from './options/country';
import ShipDateFilter from './options/ship-date';
import ShippingAccountFilter from './options/shipping-account';
import RefundStatusFilter from './options/refund-status';

const popularShippingFilterIds = [
  StoreFilter.id,
  CarrierFilter.id,
  ShipFromFilter.id,
  CountryFilter.id,
  ShipDateFilter.id,
  ShippingAccountFilter.id,
  RefundStatusFilter.id,
];

export const popularFilterByOptions = [
  StoreFilter,
  CarrierFilter,
  ShipFromFilter,
  CountryFilter,
  ShipDateFilter,
  ShippingAccountFilter,
  RefundStatusFilter,
];

export const otherFilterByOptions = AllFilterOptions.filter((option) => !popularShippingFilterIds.includes(option.id));
